import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import type { InputProps } from '../../../../types/Form';
import InputError from '../Error';
import Label from '../Label';
import styles from './Input.module.css';

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      value,
      id,
      name,
      type,
      error,
      required,
      placeholder,
      pattern,
      customClassName = '',
      disabled,
      blurChanged,
      changed,
      onChange,
      onBlur,
      max,
      className = '',
      ...rest
    },
    ref
  ) => {
    return (
      <div className={`${customClassName}`}>
        {label && <Label htmlFor={id}>{label}</Label>}
        <input
          className={twMerge([
            disabled && styles['form-input-disabled'],
            error && styles['form-input-error'],
            styles['form-input-normal'],
            className,
          ])}
          type={type}
          id={id}
          name={name}
          ref={ref}
          required={required}
          value={value}
          max={max}
          placeholder={placeholder}
          pattern={pattern}
          autoComplete={id}
          disabled={disabled}
          onChange={changed || onChange}
          onBlur={blurChanged || onBlur}
          {...rest}
        />
        {error && <InputError>{error.toString()}</InputError>}
      </div>
    );
  }
);

export default Input;
